<template>
  <div style="height: 100%;" >
    <!-- <div style="height: 100%;" class="d-flex justify-center"> -->
      <div class="start-meet-layout" v-show="status">
      <!-- <u-user-form-group :channel.sync="channel" @click="StartMeet" /> -->
      <div v-if="checkStateClickState" style="font-size: 20px; font-weight: 900; color: #20409C;">
          <v-progress-circular model-value="20" color="primary" class="mx-1" indeterminate :size="35" :width="6"></v-progress-circular>
          กำลังสร้างห้อง...
      </div>
        <v-btn v-else style="font-size: 16px;" color="primary" rounded @click="StartMeet(channel_name)">{{ btnText }}</v-btn>
    </div>
    <!-- </div> -->
    <div class="meet-layout" v-show="!status">
      <u-user-calling v-model="credential" ref="call" @end="EndCalling" disableRecordBtn disableAutoLeave />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      channel_name: '',
      valid: false,
      status: true,
      credential: { token: '', appid: '', channel: '', uid: '', features: [] },
      // แก้ ปัญหา User ทำการ click หลายครั้ง
      checkStateClickState: false
    }
  },
  created () {
    this.channel_name = this.$route.params.channel_name || ''
  },
  methods: {
    async StartMeet (channel) {
      this.checkStateClickState = true
      try {
        // this.credential = await this.GetAgoraCredentialGroup2(channel)
        const res = await this.GetAgoraCredentialGroup(channel)
        this.credential = res.data
        // console.log(this.credential.uid)
        // console.log(this.storeGetUserInfo.user_id)
        // const listOfselectedToMeeting = this.credential.filter(function (el) {
        //   return el.uid === this.storeGetUserInfo.user_id
        // })
        // console.log(listOfselectedToMeeting)
        await this.$refs.call.clickJoin()
        this.checkStateClickState = false
        this.status = !this.status
      } catch (err) {
        this.checkStateClickState = false
        this.$notification.error({
          message: 'Error',
          description: err.message,
          placement: 'bottomRight'
        })
      }
    },
    async EndCalling () {
      this.status = true
      this.credential = {
        appid: '',
        token: '',
        channel: '',
        uid: '',
        features: []
      }
    }
  },
  computed: {
    ...mapGetters(['storeGetUserInfo']),
    btnText () {
      return this.channel_name ? 'เข้าร่วมการประชุม' : 'เริ่มการประชุม'
    },
    btnTextTooltip () {
      return this.channel_name ? 'คลิกที่นี่เพื่อเข้าร่วมการประชุม' : 'คลิกที่นี่เพื่อเริ่มการประชุม'
    }
  }
}
</script>

<style lang="scss" scoped>
.main-layout {
  // background: red;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  // display: block;
  position: relative;
  z-index: 0;
}

// # start-meet-layout-------------------------
.start-meet-layout {
  // background: #f6f8ff;
  // background: rgb(224, 255, 226);
  width: 100%;
  height: 100%;
  // margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  //position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 2;
}
// # meet-layout -----------------------------

.meet-layout {
  background: #f6f8ff;
    // background: #4a5dad;

  width: 100%;
  height: 100%;
  // max-height: 300px;
  // position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 1;

  // display: none;
}

</style>
